import React, { Component } from "react";
import AuthService from "../services/auth.service";

/*---------------------------------------------------------------------------
 * Catches any render/lifecycle throw so a single bad component cannot unmount
 * the whole tree and leave the user on a blank page with no way out.
 *--------------------------------------------------------------------------*/
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.handleReload = this.handleReload.bind(this);
    this.handleSignOut = this.handleSignOut.bind(this);
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Unhandled UI error:", error, errorInfo);
  }

  handleReload() {
    window.location.href = "/";
  }

  handleSignOut() {
    AuthService.logout();
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="d-flex align-items-center justify-content-center vh-100 px-3">
        <div className="text-center">
          <h4 className="fw-bold mb-3">Something went wrong</h4>
          <p className="text-bod-secondary mb-4">
            We hit an unexpected error loading this page. You can try again, or
            sign out and start over.
          </p>
          <button
            className="btn btn-primary me-2"
            type="button"
            onClick={this.handleReload}
          >
            Try again
          </button>
          <button
            className="btn btn-outline-secondary"
            type="button"
            onClick={this.handleSignOut}
          >
            Sign out and start over
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
